import script from "./WinnerPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./WinnerPopup.vue?vue&type=script&setup=true&lang=js"

import "./WinnerPopup.vue?vue&type=style&index=0&id=1fda71ff&scoped=true&lang=scss"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fda71ff"]])

export default __exports__